import { getData, postData } from "../utils";

export async function getUserByAddress(address) {
  try {
    const url = `/api/v1/get_user/${address}`;
    const response = await getData(url);
    return response.data.user;
  } catch (err) {
    return Promise.reject(err);
  }
}

export async function createUser(signature, email, username) {
  // const signature = await signMessage("nice2win");
  const res = await postData("/api/v1/sign_account", {
    signature: signature,
    email: email,
    username: username,
  });
  if (!res.success) {
    throw new Error("Error while creating user");
    // if (res.err.code === 11000) {
    //   if (res.err.keyValue.email || res.err.keyValue.emailLowerCase) {
    //     throw new Error("duplicate email");
    //   } else if (
    //     res.err.keyValue.username ||
    //     res.err.keyValue.usernameLowercase
    //   ) {
    //     throw new Error("duplicate username");
    //   } else if (res.err.keyValue.address) {
    //     throw new Error("duplicate metamask address");
    //   } else {
    //     throw new Error("error while creating user");
    //   }
    // }
  }
  return res;
}
